import React, { useState, useRef, useEffect } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  ArrowBackIos,
  ArrowForwardIos,
  ConstructionOutlined,
} from "@mui/icons-material";
import category1 from "../../assets/images/Home_page_image/categories1.png";
import category2 from "../../assets/images/Home_page_image/categories2.png";
import category3 from "../../assets/images/Home_page_image/categories3.png";
import category4 from "../../assets/images/Home_page_image/categories.4.png";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch } from "../../hooks";
import { Link } from "react-router-dom";

const categories = [
  {
    name: "Estate Agents For Residential Rental",
    image: category1,
    color: "#F79942",
  },
  { name: "Real Estate Agents", image: category2, color: "#F79942" },
  { name: "Estate Agents For Residence", image: category3, color: "#F79942" },
  { name: "Banquet Halls", image: category4, color: "#F79942" },
  { name: "Interior Designers", image: category1, color: "#F79942" },
  { name: "Interior Designers", image: category1, color: "#F79942" },
  {
    name: "Estate Agents For Residential Rental",
    image: category1,
    color: "#F79942",
  },
  { name: "Real Estate Agents", image: category2, color: "#F79942" },
  { name: "Estate Agents For Residence", image: category3, color: "#F79942" },
  { name: "Interior Designers", image: category1, color: "#F79942" },
];

const PopularSearches = () => {
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const scrollRef = useRef(null);
  const apptoken = useSelector((state) => state.user.apptoken);
  const [data, setData] = useState([]);
  const [listingCategories, setListingCategories] = useState([]);
  const latitude = useSelector(
    (state) => state.user.userLocation?.latitude ?? null,
  );
  const longitude = useSelector(
    (state) => state.user.userLocation?.longitude ?? null,
  );
  const handleImageClick1 = (categoryName) => {
    navigate(`/toplist/${categoryName.toLowerCase()}`);
  };

  const handleImageClick = async (categoryId) => {
    const radius = 20;
    const vtype = "listing";
    try {
      const response = await fetch(
        `${BASE_URL_TEST}/api/main/vendors?lat=${latitude}&lng=${longitude}&radius=${radius}&vtype=${vtype}&categoryids=${categoryId}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      if (data?.vendors) {
        const formattedVendors = data.vendors.map((item) => ({
          id: item.id,
          name: item.name,
          shopName: item.shop_name,
          location: item.location || item.city,
          city: item.city,
          listing: item.listing,
          listingName: item.listing?.name,
          category: item.listing?.name,
          description:
            Array.isArray(item.categories) && item.categories.length > 0
              ? item.categories.map((c) => c.description).join(", ")
              : Array.isArray(item.listCategories) &&
                  item.listCategories.length > 0
                ? item.listCategories.map((c) => c.description).join(", ")
                : "",
          image: item.store_image,
          // distance: item.distance
          //   ? `${item.distance} kms near to your Location`
          //   : "N/A",
          distance: `${item.distance} kms near to your Location`,
          rating: "4.8" || "N/A",
          address: `${item.street}, ${item.city}, ${item.state}, ${item.country}, ${item.pincode}`,
          openTime: item.open_time,
          closeTime: item.close_time,
          latitude: item.latitude,
          longitude: item.longitude,
          phoneNumber: item.phone_number,
          regularListType: item.reg_list_type,
        }));

        const categorySlug = listingCategories
          .find((item) => item.categoryId === categoryId)
          ?.name.replace(/\s+/g, "-")
          .toLowerCase();

        navigate(`/toplist/${categorySlug}`, {
          state: { vendors: formattedVendors, categoryName: categoryId },
        });

        console.log("Formatted Vendors data:", formattedVendors);
      } else {
        console.error("No vendors found in the response data");
      }
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  //get All listing categories
  useEffect(() => {
    if (apptoken) {
      fetchData();
    }
  }, [apptoken]);

  //get All listing categories
  const {
    data: listingData,
    isLoading: isListingDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    if (listingData && listingData.data) {
      const filteredData = listingData.data.filter((item) => item.status === 1);

      if (filteredData.length > 0) {
        const dynamicListingCategories = filteredData.map((item) => ({
          name: item.name,
          description: item.description,
          image: item.image_url,
          categoryId: item.category_id,
        }));
        setListingCategories(dynamicListingCategories);
      } else {
        setListingCategories([]);
      }
    }
  }, [listingData]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth * 0.8;
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        overflow: "hidden",
        padding: "1rem 0",
      }}
      spacing={isSmallScreen ? 2 : 4}
    >
      {/* Container for title and See All link */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            textAlign: { xs: "center", lg: "left" },
            marginLeft: { lg: "2.5rem" },
            fontSize: {
              xs: "1rem",
              sm: "1.5rem",
              md: "1.75rem",
              lg: "1.75rem",
            },
            fontWeight: "bold",
            color: "#333",
          }}
        >
          {/* Top List Searches */}
          Near by Services
        </Typography>

        <Typography
          variant="body1"
          component={Link}
          to="/see-allTopListSearches"
          sx={{
            textDecoration: "none",
            color: "#f57c00",
            fontWeight: "bold",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          See All
        </Typography>
      </Box>

      {listingCategories.length > 0 && (
        <Box>
          <IconButton
            onClick={() => scroll("left")}
            sx={{
              position: "absolute",
              left: "0.5rem",
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "#fff",
              zIndex: 2,
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
              display: { xs: "none", sm: "flex" },
            }}
          >
            <ArrowBackIos />
          </IconButton>

          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollBehavior: "smooth",
              paddingX: { xs: 1, sm: 3, md: 5 },
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            {listingCategories.map((listingcategory, index) => (
              <Box
                item
                key={listingcategory.name}
                sx={{
                  flex: "0 0 auto",
                  width: { xs: "90%", sm: "48%", md: "32%", lg: "21%" },
                  minWidth: "200px",
                  maxWidth: "300px",
                  height: "320px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Card
                  sx={{
                    width: "230px",
                    height: "250px",
                    borderRadius: "10px",
                    overflow: "hidden",
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={listingcategory.image}
                    alt={listingcategory.image}
                    onClick={() => handleImageClick(listingcategory.categoryId)}
                  />
                  <CardContent
                    sx={{
                      backgroundColor: "#F79942",
                      color: "white",
                      textAlign: "center",
                      flexGrow: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography variant="subtitle1" gutterBottom>
                      {listingcategory.name}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Box>

          <IconButton
            onClick={() => scroll("right")}
            sx={{
              position: "absolute",
              right: "0.5rem",
              top: "50%",
              transform: "translateY(-50%)",
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "#fff",
              zIndex: 2,
              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
              display: { xs: "none", sm: "flex" },
            }}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default PopularSearches;
